import { render, staticRenderFns } from "./TheSidebarAdmin.vue?vue&type=template&id=2b4a8776&scoped=true"
import script from "./TheSidebarAdmin.vue?vue&type=script&lang=js"
export * from "./TheSidebarAdmin.vue?vue&type=script&lang=js"
import style0 from "./TheSidebarAdmin.vue?vue&type=style&index=0&id=2b4a8776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a8776",
  null
  
)

export default component.exports